export const getSaveSourcingFilterValidationSchemaFunc = () =>
  Promise.resolve({
    filterName: { type: 'string', required: true },
  });
